
//-------------------------------------//
document.addEventListener("DOMContentLoaded",function(){
  $(".open-added-basket-modal").on("click", function (e) {
    if($(window).width() >= 769){
      $(".js-go-cart-add-to-cart").trigger("click");
    }
    if($(window).width() < 769){
      $("#mobile-add-to-cart-modal").addClass("opened");
      $('body').append('<div class="modal-backdrop fade show"></div>');
      addToCartModalOpened = true;
    }
  });
  $(".js-go-cart-add-to-cart").click(function () {
    if (addToCartModalOpened) {
      return;
    }
    if ($(window).width() > 350) {
      $(".desktop-pdp-tab").css("display", "block");
      $("#desktop-buy-confirm").addClass("modal-open");
      $("#desktop-buy-confirm").modal("show");
      addToCartModalOpened = true;
    }
  });
  const hideAddCartModal = () => {
    const $confirmModal = $("#desktop-buy-confirm");
    if (!$confirmModal || !$confirmModal.length || !addToCartModalOpened) {
      return;
    }
    $confirmModal.removeClass("modal-open");
    $confirmModal.modal("hide");
    addToCartModalOpened = false;
  };
  $(".desktop-pdp-tab .krc-modal-close").click(function () {
    if ($(window).width() > 350) {
      $(".desktop-pdp-tab").css("display", "none");
      $(".modal-backdrop.show").css("display", "none");
      $("#desktop-buy-confirm").removeClass("modal-open");
      $("#desktop-buy-confirm").modal("hide");
    }
  });
  $(".proceed-shopping .continue a").on("click", function (e) {
    $(".mobile-pdp-tab").css("bottom", "-200%");
    $(".modal-backdrop").remove();
    $("body").removeClass("pdp-tab-mobile-active");
    $("html").removeClass("pdp-tab-mobile-active");
  });
  
  $("#mobile-add-to-cart-modal .close").click(function(){
    $("#mobile-add-to-cart-modal").removeClass("opened");
    $('.modal-backdrop').remove();
    window.location.reload();
  });
  $("#mobile-add-to-cart-modal .continue-btn").click(function(){
    window.location.reload();
  });
  
  $(".desktop-pdp-tab .krc-modal-close").click(function () {
    window.location.reload();
  });
  
  $("#desktop-buy-confirm .krc-modal-close").click(function () {
    window.location.reload();
  });
  $("#desktop-buy-confirm").mousedown(function (event) {
    event.stopPropagation();
  });
  
  $(document).mousedown(function (e) {
    hideAddCartModal();
  });
  
  $(".desktop-pdp-tab .inner .buttons div a.continue-btn").click(function () {
    window.location.reload();
  });
  
  $("#desktop-buy-confirm .continue-btn").click(function () {
    if ($(window).width() > 350) {
      window.location.reload();
    }
  });
  $("#quantity").change(function (e) {
    $(".gtm-detail-addtobasket").attr(
      "data-quantity",
      $(e.target).find(":selected").val()
    );
    $("#gtm-preferences").attr(
      "data-quantity",
      $(e.target).find(":selected").val()
    );
  });
  
  // Slider: Product Main Slder Thumb
  const swiperProductMainThumbnail = new Swiper(
    ".swiper-container-product-main-thumbnail",
    {
      spaceBetween: 10,
      slidesPerView: 3.5,
      loop: false,
      lazy: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      direction: "vertical",
    }
  );
  
  // Slider: Product Main Slder
  const swiperProductMainDesktop = new Swiper(
    ".swiper-container-product-main-desktop",
    {
      direction: "horizontal",
      loop: false,
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      lazy: true,
      spaceBetween: 0,
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
      resizeObserver: true,
      thumbs: {
        swiper: swiperProductMainThumbnail,
      },
    }
  );
  // Slider: Product Main Slder
  const swiperProductMain = new Swiper(".swiper-container-product-main", {
    direction: "horizontal",
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true,
    },
    resizeObserver: true,
    thumbs: {
      swiper: swiperProductMainThumbnail,
    },
  });
  
  let addToCartModalOpened = false;

  // $("#judgeme_product_reviews").addClass("d-none");
  const targetNode = document.querySelector("#judgeme_product_reviews");

  const refreshReview = () => {
    const reviews = document.querySelectorAll(".spr-review");
    if (reviews) {
      reviews.forEach((element) => {
        const avatar = element.querySelector(".spr-avatar");
        if (!avatar) {
          const titles = element.querySelectorAll(
            ".spr-review-header-byline strong"
          );
          const title = titles[0].innerHTML;
          const avatarDiv = `<div class='spr-avatar'>${title[0]}</div>`;
          const injectDiv = element.querySelector(".spr-review-header");
          injectDiv.innerHTML = injectDiv.innerHTML + avatarDiv;
        }
      });
      if (reviews[0]) {
        const titleArraySamples = reviews[0].querySelectorAll(
          ".spr-review-header-byline strong"
        );
        const titleSample = titleArraySamples[0].innerHTML;
        const dateSample = titleArraySamples[1].innerHTML;
        const commentBody = reviews[0].querySelector(
          ".spr-review-content-body"
        ).innerHTML;
        const starBody = reviews[0].querySelector(
          ".spr-review-header-starratings"
        ).innerHTML;

        const sampleReview = document.querySelector(
          ".commentPreviewNew .inner"
        );
        const sampleReviewDiv = document.querySelector(".commentPreviewNew");

        sampleReviewDiv.classList.add("active");
        const sampleReviewInject = `<div class="author">
                                                <div class="name">
                                                    <div class="avatar">
                                                        <span>${titleSample[0]}</span>
                                                    </div>
                                                    <div class="namesurname">
                                                        <span>${titleSample}</span>
                                                        <span>${dateSample}</span>
                                                    </div>
                                                </div>
                                                <div class="rating align-self-start">
                                                    ${starBody}
                                                </div>
                                            </div>
                                            <div class="comment">
                                            ${commentBody}
                                            </div>`;
        sampleReview.innerHTML = sampleReviewInject;
      }
    }
  };
  const config = { childList: true };
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        refreshReview();
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

});
$(document).ready(function () {  
  const login_true = document.getElementById("myLogin");

  const spr_action=document.querySelector('.jdgm-rev-widg__header');
  const reviewContainer = document.querySelector('.jdgm-rev-widg');
  const reviewHeaderContainer = document.querySelector('.jdgm-rev-widg__header');
  const reviewBodyContainer = document.querySelector('.jdgm-rev-widg__body');
  if(spr_action){
      if(login_true.classList.contains('login-true')){
          spr_action.classList.add('d-block');
      }
  }
  if(login_true.classList.contains('login-true')){
    reviewHeaderContainer.style.display='block';
    reviewBodyContainer.classList.add('half-width');
    reviewHeaderContainer.classList.add('half-width');
  }else{
    reviewContainer.classList.add('full-width');
  }
  const doc = document.getElementById("judgeme_product_reviews");
  const div = document.createElement("div");
  const parentDiv = doc.parentNode;
  div.classList = "mobile-pdp-tab overflow-auto";
  div.id = "mobile-reviews";
  div.innerHTML = ` 
    <div class="heading">
        <div class="close kesten-close"><button><i class="krc-close"></i></button></div>
    </div>`;

  //this code is working the for mobile device
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    parentDiv.insertBefore(div, doc);
    div.appendChild(doc);
  }

  $(
    ".see-all-link-div,.review-col,#review-mobile-btn,.mobileYorumlarClick,.see-all-reviews"
  ).on("click", function (e) {
    //if(login_true.classList.contains('login-true')){
    $("#judgeme_product_reviews").addClass("active");
    $(".review-tab").addClass("active");

    $("#product-description").removeClass("d-block");
    $("#product-description").addClass("d-none");
    $("#technical-specifications").removeClass("d-block");
    $("#technical-specifications").addClass("d-none");
    $("#refund-content").removeClass("d-block");
    $("#refund-content").addClass("d-none");

    //this code is working the for mobile device
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      div.style.bottom = "-25%";
      document.querySelector(".kesten-close").addEventListener("click", () => {
        div.style.bottom = "-200%";
      });
    }

    //}
  });
  $(".segment-button").on("click", function (event) {
    if (event.target.id === "review-tab") {
      $("#judgeme_product_reviews").addClass("active");
    } else {
      $("#judgeme_product_reviews").removeClass("active");
    }
  });
});